// Frontend Configuration
// Change ENV here to switch between development and production.
const ENV = 'production'; // 'development' or 'production'

// Port Configuration
const FRONTEND_PORT = 3000;
const BACKEND_PORT = 3001;

// Domain Configuration.
const PRODUCTION_CONFIG = {
  BACKEND_DOMAIN: 'https://lokelection-backend.lokelection.com',
  FRONTEND_DOMAIN: 'https://demo.lokelection.com',
};

const DEVELOPMENT_CONFIG = {
  BACKEND_DOMAIN: `http://localhost:${BACKEND_PORT}`,
  FRONTEND_DOMAIN: `http://localhost:${FRONTEND_PORT}`,
};

// Auto-select config based on ENV
const activeConfig = ENV === 'production' ? PRODUCTION_CONFIG : DEVELOPMENT_CONFIG;

const config = {
  // Environment
  NODE_ENV: ENV,

  // Backend API URLs (auto-switches based on ENV)
  NEXT_PUBLIC_API_URL: activeConfig.BACKEND_DOMAIN,
  API_BASE_URL: activeConfig.BACKEND_DOMAIN,
  SOCKET_URL: activeConfig.BACKEND_DOMAIN,

  // Frontend URL (auto-switches based on ENV)
  NEXT_PUBLIC_SITE_URL: activeConfig.FRONTEND_DOMAIN,

  // Google Maps API Key (Add your key here or use environment variable)
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: 'AIzaSyAWE7hK3B09vNt6N81So0oboih-GW9QnsA',

  // CORS Origins (auto-switches based on ENV)
  CORS_ALLOWED_ORIGINS: ENV === 'production'
    ? [
      PRODUCTION_CONFIG.FRONTEND_DOMAIN,
      PRODUCTION_CONFIG.BACKEND_DOMAIN,
      'https://demo.lokelection.com',
      'https://lokelection-backend.lokelection.com',
    ]
    : [
      `http://localhost:${FRONTEND_PORT}`,
      `http://localhost:${BACKEND_PORT}`,
      `http://127.0.0.1:${FRONTEND_PORT}`,
      `http://127.0.0.1:${BACKEND_PORT}`,
    ],
};

export default config;
